import Card from '@/components/Card';
import Stack from '@/components/Stack';
import { Body, Small } from '@/components/Typography';
import Badge from '@/components/Badge';
import { AssessmentAnswer } from '@/services/workersV2API';

type Props = {
  assessmentAnswers: AssessmentAnswer[];
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}m ${secs}s`;
};

const AssessmentAnswersCard = ({ assessmentAnswers }: Props) => {
  if (!assessmentAnswers || assessmentAnswers.length === 0) {
    return (
      <Card title="Assessment Answers (0)">
        <Card.Section>
          <Stack style={{ justifyContent: 'center', padding: '20px' }}>
            <Small color="lighter">No assessment answers found</Small>
          </Stack>
        </Card.Section>
      </Card>
    );
  }

  return (
    <Card title={`Assessment Answers (${assessmentAnswers.length})`}>
      {assessmentAnswers.map((answer) => (
        <Card.Section key={answer.id}>
          <Stack vertical gap={16}>
            <Stack
              style={{ justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Body weight="semibold">{answer.skill_name}</Body>
              <Badge
                label={answer.is_passing ? 'Passed' : 'Failed'}
                status={answer.is_passing ? 'theme' : 'danger'}
              />
            </Stack>

            <Stack
              vertical
              gap={8}
              style={{
                padding: '16px',
                backgroundColor: answer.is_passing ? '#F0F9FF' : '#FEF2F2',
                borderRadius: '8px',
              }}
            >
              <Stack style={{ justifyContent: 'space-between' }}>
                <Small color="lighter">Score</Small>
                <Body weight="semibold">{answer.percentage.toFixed(1)}%</Body>
              </Stack>

              <Stack style={{ justifyContent: 'space-between' }}>
                <Small color="lighter">Correct Answers</Small>
                <Body>
                  {answer.correct_answers_count} / {answer.total_questions}
                </Body>
              </Stack>

              <Stack style={{ justifyContent: 'space-between' }}>
                <Small color="lighter">Time Taken</Small>
                <Body>{formatTime(answer.total_time_seconds)}</Body>
              </Stack>
            </Stack>

            <Stack gap={16}>
              <Small color="lighter">
                Completed: {formatDate(answer.answered_at)}
              </Small>
            </Stack>
          </Stack>
        </Card.Section>
      ))}
    </Card>
  );
};

export default AssessmentAnswersCard;
